import type { IconData } from '@stacksjs/iconify-core'

export const padlockKey: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M7.23 25q.049-.662.1-1.238c.228-2.505 2.235-4.311 4.746-4.446C15.013 19.16 19.576 19 26 19c6.425 0 10.987.16 13.924.316c2.511.135 4.518 1.941 4.745 4.446c.18 1.973.331 4.69.331 8.238s-.152 6.265-.33 8.238c-.228 2.505-2.235 4.312-4.746 4.446q-.657.035-1.424.07\"/><path d=\"m31.532 19.043l-.238-4.052a5.303 5.303 0 0 0-10.587 0l-.239 4.052m18.89.244l-.44-5.283A12 12 0 0 0 26.957 3h-1.916a12 12 0 0 0-11.959 11.004l-.44 5.283M10 44a7 7 0 1 1 6.326-10H31a3 3 0 0 1 3 3v5a3 3 0 1 1-6 0v-2h-1v2a3 3 0 1 1-6 0v-2h-4.674A7 7 0 0 1 10 44m-1-7h2\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default padlockKey
